import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, RouterEvent } from '@angular/router';
import { ICtoContract, ICtoRetailPlace } from '../../../core/models/cto.model';
import { CtoApiService } from '../../../core/modules/cto/cto-api.service';
import { IDetailsRequestBody } from '../../../core/modules/cto/cto.types';

@Component({
  selector: 'tax-cto-details',
  templateUrl: './cto-details.component.html',
  styleUrls: ['./cto-details.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtoDetailsComponent implements OnInit, OnDestroy {
  private subscription: Subscription[] = [];
  searchCriteria: string = '';
  // @ts-ignore
  contractId: string;
  // @ts-ignore
  contract: ICtoContract;
  retailPlaces: Array<ICtoRetailPlace> = [];
  // @ts-ignore
  tags: { [key: string]: number };
  seletedTags: Array<string> = [];
  pagination: number = 0;
  isFullLoaded: boolean = false;
  readonly PAGINATION_STEP: number = 3;

  constructor(
    private ctoApiService: CtoApiService,
    private changeDetector: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    // @ts-ignore
    this.contractId = this.activatedRoute.snapshot.paramMap.get('id');
    this.subscription.push(
      this.getContract(this.contractId),
      this.getContractDetails(this.getRequestBody(this.pagination, this.PAGINATION_STEP - 1), true),
    );
  }

  private getRequestBody(paginationFrom: number, paginationTo: number): IDetailsRequestBody {
    return {
      contractId: Number(this.contractId),
      tags: this.seletedTags,
      criteria: this.searchCriteria,
      pagination:
        {
          from: paginationFrom, to: this.pagination += paginationTo,
        },
    };
  }

  getContract(contractId: string): Subscription {
    return this.ctoApiService.fetchContract(contractId).subscribe(
      (response: ICtoContract) => {
        this.contract = response;
        this.changeDetector.markForCheck();
      },
    );
  }

  private getContractDetails(requestBody: IDetailsRequestBody, isFirstRequest: boolean): Subscription {
    return this.ctoApiService.fetchCtoDetails(requestBody).subscribe(
      (response: { groupedTags: { [key: string]: number }; retailPlaces: Array<ICtoRetailPlace> }) => {
        this.isFullLoaded = response.retailPlaces.length < this.PAGINATION_STEP;
        if (isFirstRequest) {
          this.retailPlaces = [];
        }
        this.retailPlaces = this.retailPlaces.concat(response.retailPlaces);
        if (isFirstRequest) {
          this.tags = response.groupedTags;
        }
        this.changeDetector.detectChanges();
      },
    );
  }

  searchFieldChange(event: Event | RouterEvent): void {
    if (event instanceof RouterEvent) return;

    this.pagination = 0;
    const searchCriteria: string = (event.target as HTMLInputElement).value;
    if (searchCriteria) {
      this.seletedTags = [];
    }
    this.subscription.push(
      this.getContractDetails(this.getRequestBody(this.pagination, this.PAGINATION_STEP), true),
    );
  }

  selectTag(tagTitle: string): void {
    this.searchCriteria = '';
    this.pagination = 0;
    this.isTagSelected(tagTitle)
      ? this.seletedTags = this.seletedTags.filter((item: string) => item !== tagTitle)
      : this.seletedTags.push(tagTitle);
    this.subscription.push(
      this.getContractDetails(this.getRequestBody(this.pagination, this.PAGINATION_STEP), true),
    );
  }

  isTagSelected(tagTitle: string): boolean {
    return this.seletedTags.includes(tagTitle);
  }

  loadMore(): void {
    this.subscription.push(
      this.getContractDetails(this.getRequestBody(this.pagination + 1, this.PAGINATION_STEP), false),
    );
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
